import { AuthService, type VerifyPhoneBodyDto } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

type TParams = {
  call: TCall;
  requestBody: VerifyPhoneBodyDto;
};

export const verifyPhone = ({ call, requestBody }: TParams) => call(() => AuthService.verifyPhone({ requestBody }));
